import { LMFormatUtilService } from '@services/utils/lm-format-util.service';
import { LMConditionUtilService } from '@utils/lm-condition-util.service';
import { AppConstants, LMTransformOptions } from '@utils/index';

export const lmMatrixRowFormatter = (
  lmFormatUtilService: LMFormatUtilService,
  lmConditionUtilService: LMConditionUtilService,
  matrixFormSpec: LMBusMatrixFormSpec,
  showDetailFields: boolean,
  row: number,
  cell: number,
  value: any,
  columnDef: ListGridColumn,
  dataView: LMDataView,
  dataGrid: SohoDataGridStatic
): string => {
  // console.log('columnDef.id: ' + columnDef.id + ' ' + columnDef.matrixIndex);
  const matrixCellIndex = columnDef.id === 'ROW_HEADER' ? 0 : columnDef.matrixIndex;
  const cellDataView: LMDataView = dataView.data[matrixCellIndex];

  // should NOT happen
  if (!cellDataView) {
    return '';
  }

  const markup = [];

  if (columnDef.id === 'ROW_HEADER') {
    // matrix row view
    matrixFormSpec.cells.forEach((displayField: LMListDisplayField) => {
      if (displayField.detail && !showDetailFields) {
        return;
      }

      let label = '';

      if (displayField.label) {
        let messageRule: any = displayField.label;

        if (messageRule.label) {
          // spec is messed up here when the displayField is a button
          messageRule = messageRule.label;
        }

        label = lmFormatUtilService.formatMessageRule(messageRule, cellDataView, matrixFormSpec.fields);
      }

      markup.push(`<div class="lm-matrix-element">${label}</div>`);
    });
  } else {
    // matrix column views
    matrixFormSpec.cells.forEach((displayField: LMListDisplayField) => {
      if (displayField.detail && !showDetailFields) {
        return;
      }

      const field: LMField = cellDataView.fields[ displayField.fieldId ];

      if (displayField.visibility && !lmConditionUtilService.isValid(displayField.visibility, cellDataView)) {
        markup.push(`<div class="lm-matrix-element"></div>`);
      } else if (displayField.condition && !lmConditionUtilService.isValid([displayField.condition], cellDataView)) {
        markup.push(`<div class="lm-matrix-element"></div>`);
      } else if (displayField.type === AppConstants.CHECKCONTROL) {
        // TODO Need work in java to bring back actionindex on cell dataview so can determine
        // if the check action is valid
        markup.push(`
          <div class="lm-matrix-element field" style="margin:0">
            <input
              type="checkbox"
              class="checkbox"
              name="lm-checkbox-${row}_${cell}"
              id="lm-checkbox-${row}_${cell}"
              ${isChecked(displayField) ? 'checked' : ''}
            />
            <label data-navigation-params='${JSON.stringify(displayField)}' for="lm-checkbox-${row}_${cell}" class="checkbox-label"></label>
          </div>
        `);
      } else if (displayField.navigation) {
        const buttonTitle = lmFormatUtilService.formatMessageRule(displayField.title, cellDataView);
        const hyperlinkDisplayValue = `${lmFormatUtilService.toDisplayValue(buttonTitle, displayField.type)}`;
        const hyperlinkClasses = 'lm-matrix-element hyperlink lm-card-internal-link';
        markup.push(`<div><a href="#" class="${hyperlinkClasses}" data-navigation-params='${JSON.stringify(displayField)}'>${hyperlinkDisplayValue}</a></div>`);
      } else if (!field) {
        markup.push(`<div class="lm-matrix-element"></div>`);
      } else if (displayField.linkNavigation) {
        const hyperlinkDisplayValue = `${getFieldDisplayValue(displayField, field)}`;
        const hyperlinkClasses = 'lm-matrix-element hyperlink lm-card-internal-link';
        markup.push(`<div><a href="#" class="${hyperlinkClasses}" data-navigation-params='${JSON.stringify(displayField)}'>${hyperlinkDisplayValue}</a></div>`);
      } else {
        const displayValue = getFieldDisplayValue(displayField, field);
        markup.push(`<div class="lm-matrix-element">${displayValue}</div>`);
      }
    });
  }

  function getFieldDisplayValue(displayField: LMListDisplayField, field: LMField): string {
    let options: LMTransformOptions;
    if (displayField.type === AppConstants.BCD || displayField.type === AppConstants.PERCENT) {
      options = {decSize: field.precision, precision: field.precision};
    }
    return lmFormatUtilService.toDisplayValue(field.value, displayField.type, options);
  }

  function isChecked(displayField): boolean {
    if (displayField.hasCheckedState) {
      return cellDataView.fields[displayField.bindId].value as boolean;
    }

    return false;
  }

  return markup.join('');
};
